// extracted by mini-css-extract-plugin
export default {"footerNavContainer":"sUHFkgq8kZBVTzaS5EXD","footerNavContent":"JL31whsrMJOanH_zSAgA"};